// src/themes/mint-fresh.ts
import { Theme } from "./types";

export const mintFreshTheme: Theme = {
  "background-light": "245 255 250", // #F5FFFA - Mint cream
  "background-dark": "235 250 245", // #EBFAF5 - Soft mint
  "card-light": "255 255 255", // #FFFFFF - Pure white
  "card-dark": "250 255 253", // #FAFFFD - Frosted mint
  "input-light": "240 255 245", // #F0FFF5 - Light mint
  "input-dark": "230 250 240", // #E6FAF0 - Soft mint
  "border-light": "180 230 210", // #B4E6D2 - Mint border
  "border-dark": "160 220 200", // #A0DCC8 - Fresh mint
  primary: "0 200 180", // #00C8B4 - Vibrant teal
  "primary-hover": "0 180 160", // #00B4A0 - Rich teal
  text: "40 60 70", // #283C46 - Deep teal-gray
  "text-dark": "50 70 80", // #324650 - Rich teal
  "text-secondary": "120 150 160", // #7896A0 - Cool mint-gray
  "text-secondary-dark": "100 130 140", // #64828C - Muted teal
};
